import styled, { createGlobalStyle } from 'styled-components';

export const RealtimeToastStyles = createGlobalStyle`
  .Toastify__toast.realtime-toast {
    width: 300px;
    max-width: calc(100vw - 32px);
    min-height: 90px;
    margin-left: auto;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    padding: 16px 16px 20px 18px;
    cursor: pointer;
    color: #5e5e60;
    font-family: inherit;
    display: flex;
    align-items: flex-start;
    gap: 11px;
    position: relative;
    overflow: hidden;
  }

  .Toastify__toast.realtime-toast::after {
    content: '';
    position: absolute;
    inset: auto 0 0 0;
    height: 6px;
    background: #e6f7f2;
  }

  .Toastify__toast-body.realtime-toast__body {
    flex: 1;
    padding: 0;
    margin: 0;
    color: #5e5e60;
    font-size: 14px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0;
  }

  .Toastify__progress-bar.realtime-toast__progress {
    background: #01ab7d;
    height: 6px;
    z-index: 1;
  }

  .Toastify__toast.realtime-toast .Toastify__close-button {
    align-self: flex-start;
    color: #838486;
    opacity: 1;
  }

  @media (max-width: 480px) {
    .Toastify__toast.realtime-toast {
      width: 100%;
      max-width: none;
    }
  }
`;

export const Content = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;
  letter-spacing: 0;
  color: #5e5e60;

  strong {
    font-weight: 600;
  }
`;

export const Cta = styled.span`
  display: block;
  margin-top: 4px;
  color: #01AB7D;
  font-weight: 500;
`;
